import React from "react";
import { Toast, ToastBar } from "react-hot-toast";
import styled from "styled-components";

const ToastContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  word-break: break-word;
  min-width: 0;
  width: 100%;
`;

const ToastIconContainer = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

type Props = {
  toastEntry: Toast;
};

// Toaster component
export const ToastItem: React.FC<Props> = ({ toastEntry }) => {
  return (
    <ToastBar toast={toastEntry}>
      {({ icon, message }) => (
        <ToastContentContainer>
          <ToastIconContainer>{icon}</ToastIconContainer>
          {message}
        </ToastContentContainer>
      )}
    </ToastBar>
  );
};
